import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-anchor",
  "use": "icon-anchor-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-anchor\" id=\"icon-anchor\"><circle cx=\"12\" cy=\"5\" r=\"3\" /><line x1=\"12\" y1=\"22\" x2=\"12\" y2=\"8\" /><path d=\"M5 12H2a10 10 0 0 0 20 0h-3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol